<div class="container-fluid">
  <div class="row">
    <div class="col">
      <app-eca-input label="Job Role" [controlId]="'ctrlname'" [isRequired]="true" [isReadOnly]="isEditing"
                     popoverText="Please enter the Job Role for the Non electrical."
                     [(value)]="companyJobTitle.name"
                     [isValid]="!saveAttempted || !!companyJobTitle?.name"
                      validationMessage="Can not save empty"

                     >
                    
      </app-eca-input>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
   
    </div>
  </div>
 
  <div class="row">
    <div class="col">
      
    </div>
  </div>






</div>
